require('../navigation/anchor.js');
require('./card-result.css');
const formatText = require('../../lib/format-card-text.js').default;

const markup = /* xml */ `<db:cardresult>
	<table>
		<tr>
			<td><db:a data-id='imageLink' data-property='href'>
				<span data-id='body'>
					<img data-id='image' data-property='src' />
				</span>
			</db:a></td>
			<td>
				<header><db:a data-id='link' data-property='href'>
					<span data-id='body'><span data-id='name'></span></span>
				</db:a></header>
				<div data-id='formattedText'></div>
				<div data-id='actions'></div>
			</td>
		</tr>
	</table>
</db:cardresult>`;

const CardResult = DomClass(markup, function() {
	this.image = "http://gatherer.wizards.com/Handlers/Image.ashx?"
		+ "multiverseid=" + this.multiverseid
		+ "&type=card"
	this.link = `?cards/${encodeURIComponent(this.name)}`;
	this.imageLink = `?cards/${encodeURIComponent(this.name)}`;
	this.formattedText = formatText(this.text);
});

export default CardResult;
